<template>
  <div class="jin-form-attach">
    <div class="jin-form-attach-con">
      <span :class="className">{{ title }}</span>
      <div class="upload">
        <el-upload
          :show-file-list="false"
          class="upload-demo"
          action="https://oss-api.jin10.com/applyUploadToken/jfiles_hero_weibo/"
          :accept="accept"
          :http-request="handleUpload"
          :before-upload="beforeUpload"
          :file-list="fileList"
        >
          <el-button :loading="loading" size="small" type="primary">{{ btnName }}</el-button>
          <div slot="tip" class="el-upload__tip">{{ tips }}</div>
        </el-upload>
        <ul v-if="showList && files && files.length" class="jin-el-upload-list-pc jin-pc">
          <li v-for="(item, i) in files" :key=" i">
            <div v-if="item && item.file" class="file-con">
              <span>{{ item.file.name + ' ( ' + handleSize(item) + ')' }}</span>
              <p v-if="!item.value || item.value === 100">
                上传成功
                <span @click="onRemove(i)">删除</span>
              </p>
            </div>
            <el-progress v-if="item && item.value" color="#4777f4" :stroke-width="3" :percentage="item.value" />
          </li>
        </ul>
        <div v-if="showList && files && files.length && JSON.stringify(files[0]) !== '{}'" class="jin-m jin-el-upload-list-m">
          <p class="success">上传成功</p>
          <ul>
            <li v-for="(item, i) in files" :key="i" class="file-item">
              <div v-if="item && item.file" class="file-con">
                <p>
                  <img src="@/assets/resume/folder.png" alt="">
                  <span>{{ item.file.name + ' ( ' + handleSize(item) + ')' }}</span>
                </p>
                <span class="upload-delete" @click="onRemove(i)">删除</span>
              </div>
              <el-progress v-if="item && item.value" color="#4777f4" :stroke-width="3" :percentage="item.value" />
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { resumeApi } from '@/api'
import { upload } from '@/utils/upload-oss'
import { mapGetters, mapMutations } from 'vuex'

export default {
  props: {
    title: {
      type: String,
      default: '上传头像'
    },
    btnName: {
      type: String,
      default: '选取文件'
    },
    showLoading: {
      type: Boolean,
      default: false
    },
    className: {
      type: String,
      default: ''
    },
    accept: {
      type: String,
      default: 'image/jpg,image/jpeg,image/png,image/gif,image/JPG,image/JPEG,image/GIF'
    },
    showFileList: {
      type: Boolean,
      default: false
    },
    tips: {
      type: String,
      default: '照片1寸证件照，大小不超过5M，尺寸为295*413，格式支持png、jpg、jpeg'
    },
    path: {
      type: String,
      default: 'avatar/'
    },
    limit: {
      type: [String, Number],
      default: ''
    },
    info: {
      type: Object,
      default: () => {}
    },
    showList: {
      type: Boolean,
      default: false
    },
    size: {
      type: [Number, String, Boolean],
      default: false
    }
  },
  data() {
    return {
      value: 1,
      fileList: [],
      files: [],
      timer: null,
      loading: false
    }
  },
  computed: {
    ...mapGetters([
      'drafts',
      'resumeCon',
      'currForm'
    ])
  },
  watch: {
    info: {
      handler() {
        this.init()
      },
      deep: true
    }
  },
  created() {
    this.init()
  },
  methods: {
    ...mapMutations('resume', ['SET_FORM']),
    init() {
      if (this.info && this.drafts) {
        // console.log(this.info, this.drafts)
        // 简历
        const resume = this.info.form && this.info.form.resume ? [this.info.form.resume] : []
        this.files = this.info.type ? this.drafts[this.info.type] || [] : resume
        // this.files = this.drafts[this.info.type]
      }
    },
    handleSize(item) {
      const m = (item.file.size / 1024 / 1024)
      const kb = (item.file.size / 1024)
      const curr = m > 1 ? m.toFixed(1) + ' M' : kb.toFixed(2) + ' K'
      return curr
    },
    async handleUpload(v) {
      this.loading = this.showLoading
      let sizeFlag = false

      const acceptFlag = this.accept ? this.accept.includes(v.file.name.split('.')[1]) : true
      if (this.size) {
        sizeFlag = v.file.size / 1024 / 1024 < Number(this.size)
        if (!(v.file.size / 1024 / 1024 < Number(this.size))) return this.Toast(`上传的文件总和不能大于${this.size}M`)
      } else {
        sizeFlag = true
      }
      if (!acceptFlag) return this.Toast(this.tips)
      if (sizeFlag) {
        this.data = {
          path: this.path,
          suffix: v.file.name.split('.')[1]
        }

        if (this.limit) {
          this.files = [{
            file: v.file,
            value: 1
          }]
        } else {
          this.files.push({
            file: v.file,
            value: 1
          })
        }

        this.handleTimer(83)

        const res = await resumeApi.upload(this.data)
        await upload(res, v.file)
        if (this.showList) {
          if (this.files[this.files.length - 1]) {
            this.files[this.files.length - 1].url = res.Url
            this.files[this.files.length - 1].value = 100
          }
          setTimeout(() => {
            this.files = this.files.map(item => {
              delete item.value
              return item
            })
          }, 500)
          this.$emit('change', this.files)
        } else {
          this.$emit('change', res.Url, v.file)
        }
      }
      this.loading = false
      // this.Toast.success('上传成功')
    },
    handleTimer(num) {
      this.timer = setInterval(() => {
        if (this.files[this.files.length - 1].value >= num) {
          clearInterval(this.timer)
        } else {
          this.files[this.files.length - 1].value++
        }
      }, 50)
    },
    onRemove(i) {
      this.files.splice(i, 1)
      this.SET_FORM(this.resumeCon)
      // console.log(this.resumeCon)
      this.$emit('change', this.files)
    },
    beforeUpload(file) {
      this.$emit('beforeUpload', file)
    }
  }
}
</script>

<style lang="scss" scoped>
.jin-pc {
  .jin-form {
    &-attach {
      &-con {
        padding: 30px 20px;

        span {
          color: #787b8a;
          line-height: 22px;
        }

        .el-button {
          margin-top: 4px;
          width: 320px;
          height: 42px;
          border-color: #dddfe3;
          background: #dddfe3;
          border-radius: 4px;
          font-size: 14px;
          color: #787b8a;
        }

        .el-upload__tip {
          margin-top: 12px;
          color: #a0a4b7;
          line-height: 20px;
          font-size: 14px;
        }

        .jin-el-upload-list {
          width: 40%;
          margin-top: 10px;

          &-pc {
            li {
              .file-con {
                margin-top: 10px;
                transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);
                font-size: 14px;
                color: #3d4351;
                line-height: 28px;
                display: flex;
                align-items: center;
                justify-content: space-between;

                span {
                  color: #3d4351;
                }

                p {
                  display: flex;
                  align-items: center;

                  span {
                    cursor: pointer;
                    color: #4777f4;
                    margin-left: 10px;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

.jin-m {
  /deep/ .el-progress {
    &__text {
      font-size: 12px !important;
    }
  }

  .jin-form {
    &-attach {
      &-con {
        margin-top: 13px;
        // padding: 30px 20px;

        span {
          color: #787b8a;
          line-height: 22px;
        }

        /deep/ .el-upload {
          width: 100%;
        }

        .el-button {
          margin-top: 4px;
          width: 100%;
          height: 40px;
          border-color: #dddfe3;
          background: #dddfe3;
          border-radius: 2px;
          font-size: 13px;
          color: #787b8a;
        }

        .el-upload__tip {
          margin-top: 12px;
          color: #a0a4b7;
          line-height: 18px;
          font-size: 11px;
        }

        .jin-el-upload-list {
          &-m {
            margin-top: 24px;

            .success {
              font-size: 13px;
              color: #3d4351;
              margin-bottom: 13px;
            }

            li {
              border: 1px solid;
              background: #fff linear-gradient(360deg, rgba(255, 194, 76, 0) 0%, rgba(255, 194, 76, 0.08) 100%);
              border-image: linear-gradient(180deg, rgba(245, 245, 246, 1), rgba(232, 232, 234, 1)) 1 1;
              margin-bottom: 18px;
              padding: 15px 14px;

              .file-con {
                display: flex;
                justify-content: space-between;
                align-items: center;
                border-radius: 4px;

                p {
                  flex: 1;
                  display: flex;
                  align-items: center;
                  // justify-content: space-between;

                  img {
                    width: 24px;
                    margin-right: 10px;
                  }

                  span {
                    display: block;
                    width: 80%;
                    font-size: 12px;
                    color: #3d4351;
                    line-height: 20px;
                    word-break: break-all;
                  }
                }

                .upload-delete {
                  display: block;
                  // width: 55px;
                  font-size: 14px;
                  color: #4777f4;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
